import { create } from 'zustand';

const scrolledDirectionStore = create<{
  accumulatedDelta: number;
  // Use an accumulated inverted delta because the user may do a very minimal move
  accumulatedInvertedDelta: number;
}>(() => ({ accumulatedDelta: 0, accumulatedInvertedDelta: 0 }));

const useScrolledDirectionStore = scrolledDirectionStore; // The store can be used as a hook

// Actions

export function scrolled(delta: number) {
  const previousState = scrolledDirectionStore.getState();

  if (
    (delta < 0 && previousState.accumulatedDelta > 0) ||
    (delta > 0 && previousState.accumulatedDelta < 0)
  ) {
    if (Math.abs(previousState.accumulatedInvertedDelta) > 10) {
      scrolledDirectionStore.setState({
        accumulatedDelta: previousState.accumulatedInvertedDelta + delta,
        accumulatedInvertedDelta: 0,
      });
    } else {
      scrolledDirectionStore.setState({
        accumulatedInvertedDelta:
          previousState.accumulatedInvertedDelta + delta,
      });
    }
  } else {
    scrolledDirectionStore.setState({
      accumulatedDelta: previousState.accumulatedDelta + delta,
      accumulatedInvertedDelta: 0,
    });
  }
}

export function resetScrollDirection() {
  scrolledDirectionStore.setState({
    accumulatedDelta: 0,
    accumulatedInvertedDelta: 0,
  });
}

// Hooks

export function useScrolledDirection({ threshold }: { threshold: number }) {
  const scrolledDirection = useScrolledDirectionStore((state) => {
    if (state.accumulatedDelta < -threshold) return 'up';
    if (state.accumulatedDelta > threshold) return 'down';

    return null;
  });

  return { scrolledDirection };
}
